module.exports = __webpack_public_path__ + "static/img/2.27a9e68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/2.png
// module id = 0YT+
// module chunks = 0